import { getTimeRange } from '../../../../../../constants/helpers/dates';

import { SmsReportCreateForm } from './interfaces';

export const mapTableDataIntoApiFormat = (report: SmsReportCreateForm) => ({
  name: report.name,
  metadata: {
    timeRange: getTimeRange({ from: report.from, to: report.to }),
    statuses: report.statuses,
    operators: report.operators,
    operationIds: report.operationIds,
    recipientMsisdns: report.recipientMsisdns
  }
});
